/**
 * Returns info object for percentOff value.
 * @param {number} percentOff
 * @returns {{text: string, type: "discount"|"upcharge"}|null}
 */
export function getPercentOffInfo(percentOff) {
  if (typeof percentOff !== "number") return null;
  if (percentOff > 0) return { text: `Discounted ${percentOff}%`, type: "discount" };
  if (percentOff < 0) return { text: `Upcharged ${Math.abs(percentOff)}%`, type: "upcharge" };
  return null;
}
